import { z } from "zod";

// TODO: duplicate of dataType, should remove
export const categoryNameEnum = z.enum([
  "aerial",
  "streetscape",
  "drone",
  "exterior",
  "interior",
  "bim_exterior",
  "bim_interior",
  "twod_plan_exterior",
  "twod_plan_interior",
  "unknown",
  "custom",
  "pedestrian",
]);
export type CategoryName = z.infer<typeof categoryNameEnum>;
